/* ----------------------------------------------------------
   Coming-Soon Countdown  v1.0
   - Elements with [data-launch="YYYY-MM-DDTHH:MM:SS+TZ"] are
     auto-updated every second.
   ---------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-launch]').forEach(el => {
    const launchTime = new Date(el.dataset.launch);   // JSTが入ればそのまま
    const format = n => n.toString().padStart(2, '0');

    function tick() {
      const diff = launchTime - new Date();
      if (diff <= 0) {
        location.reload();          // 発売時刻になったらページ再読込
        return;
      }
      const d = Math.floor(diff / 864e5);
      const h = Math.floor(diff / 36e5) % 24;
      const m = Math.floor(diff / 6e4) % 60;
      const s = Math.floor(diff / 1e3) % 60;
      el.textContent = `${d}日 ${format(h)}:${format(m)}:${format(s)}`;
    }
    tick();
    setInterval(tick, 1000);
  });
});
